
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockWhsDialog extends Serenity.EntityDialog<IcStockWhsRow, any> {
        protected getFormKey() { return IcStockWhsForm.formKey; }
        protected getIdProperty() { return IcStockWhsRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockWhsRow.localTextPrefix; }
        protected getNameProperty() { return IcStockWhsRow.nameProperty; }
        protected getService() { return IcStockWhsService.baseUrl; }
        protected getDeletePermission() { return IcStockWhsRow.deletePermission; }
        protected getInsertPermission() { return IcStockWhsRow.insertPermission; }
        protected getUpdatePermission() { return IcStockWhsRow.updatePermission; }

        protected form = new IcStockWhsForm(this.idPrefix);

    }
}